import React from 'react'
import { OutboundLink } from 'gatsby-plugin-gtag'

import {
  EuiCard,
  EuiFlexGroup,
  EuiFlexItem,
  EuiSpacer
} from '@elastic/eui'

import poe1000a from "../../../images/Products/Power_over_Ethernet/IN-PoE_1000_web.webp"
import poe1000b from "../../../images/Products/Power_over_Ethernet/IN-PoE100_web_black_1.webp"
import poe4000 from "../../../images/Products/Power_over_Ethernet/IN-PoE_4000.webp"
import poe8000 from "../../../images/Products/Power_over_Ethernet/IN-PoE_8000_web.webp"


export default function PoECards() {

  return (
    <React.Fragment>
      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                  <img
                    src={poe1000a}
                    alt="IN-PoE 1000"
                  />
              }
              title='IN-PoE 1000'
              description={
                <p>The <OutboundLink to="https://www.instar.com/accessories/poe-accessories/in-poe1000-poe-injector-black.html">IN-POE 1000</OutboundLink> Power-over-Ethernet adapter to power your PoE devices - available in black or white.</p>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                  <img
                    src={poe1000b}
                    alt="IN-PoE 1000"
                  />
              }
              title='IN-PoE 1000'
              description={
                <p>The <OutboundLink to="https://www.instar.com/accessories/poe-accessories/in-poe1000-poe-injector-black.html">IN-POE 1000</OutboundLink> Power-over-Ethernet adapter - the plug & play companion for your PoE IP camera.</p>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>

      <EuiSpacer />

      <EuiFlexItem>
        <EuiFlexGroup gutterSize="l" direction="row" style={{margin: '0 7px'}} >
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                  <img
                    src={poe4000}
                    alt="IN-PoE 4000"
                  />
              }
              title='IN-PoE 4000'
              description={
                <p>The IN-POE 4000 Power over Ethernet Switches for 4 INSTAR PoE Cameras.</p>
              }
            />
          </EuiFlexItem>
          <EuiFlexItem>
            <EuiCard
              textAlign="left"
              image={
                  <img
                    src={poe8000}
                    alt="IN-PoE 8000"
                  />
              }
              title='IN-PoE 8000'
              description={
                <p>The IN-POE 8000 Power over Ethernet Switches for 7 INSTAR PoE Cameras.</p>
              }
            />
          </EuiFlexItem>
        </EuiFlexGroup>
      </EuiFlexItem>
      <EuiSpacer />
    </React.Fragment>
  );
}
